import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core'
import { EnrichmentProperty, PlannedSegment } from '../work-item'
import {
  ElderPaneComponent,
  ElderTranslatePipe,
  ElderTableComponent,
  ElderPaneHeaderComponent,
  ElderPaneContentComponent,
  ElderPaneTitleComponent,
  ElderPopoverComponent,
  ElderTruncatePipe,
  IsoDateStr,
} from '@elderbyte/ngx-starter'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { PropertySetValue } from '../bom/bom'
import { DatePipe } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'

@Component({
  selector: 'app-item-planned-segment-enrichments',
  imports: [
    DatePipe,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatButton,
    ElderTableComponent,
    ElderPaneComponent,
    ElderTranslatePipe,
    ElderPaneHeaderComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    ElderPopoverComponent,
    ElderTruncatePipe,
  ],
  templateUrl: './item-planned-segment-enrichments.component.html',
  styleUrl: './item-planned-segment-enrichments.component.scss',
})
export class ItemPlannedSegmentEnrichmentsComponent {
  public plannedSegment = input.required<PlannedSegment>()
  protected enrichmentProperties: Signal<EnrichmentProperty[]> = computed(() =>
    this.extractSegmentEnrichments(this.plannedSegment())
  ) // TODO: data source

  protected getDisplayValue(enrichmentProperty: EnrichmentProperty): string {
    const propertySetValues = enrichmentProperty.propertyValues.map(
      (value: PropertySetValue) => value.primitive
    )
    const first = propertySetValues.find((_) => true) // TODO: handle multiple values
    return first ? String(first) : ''
  }

  protected extractRequestedAt(plannedSegment: PlannedSegment): IsoDateStr | undefined {
    return plannedSegment.enrichments?.requestedAt
  }

  protected extractError(plannedSegment: PlannedSegment): string | undefined {
    return plannedSegment.enrichments?.error
  }

  private extractSegmentEnrichments(segment: PlannedSegment): EnrichmentProperty[] {
    const propertyById = segment.enrichments?.propertyById ?? new Map<string, EnrichmentProperty>()
    const res = [...Object.values(propertyById)] // in reality the JSON is parsed into an Object, not a map
    return res
  }
}
